import React from 'react';
import { connect } from 'react-redux';
import { updateCamset } from '../../actions';
import { paginationTemplate4, paginationTemplate6, paginationTemplate9, paginationTemplate12, paginationTemplate16 } from './paginationTemplate';
import '../../App.css';

const LayoutPagination = props => {

  const returnLayout = () => {
    let numCams = props.compositeCams.length;
    // let layout4 = [ ...Array(Math.ceil(numCams / 4)).keys() ];
    let layout4 = Array.from({ length: Math.ceil(numCams / 4) }, (_, i) => i) // get the number of multiple 4 views we need to show
    let layout6 = Array.from({ length: Math.ceil(numCams / 6) }, (_, i) => i) // get the number of multiple 6 views we need to show
    let layout9 = Array.from({ length: Math.ceil(numCams / 9) }, (_, i) => i) // get the number of multiple 9 views we need to show
    let layout12 = Array.from({ length: Math.ceil(numCams / 12) }, (_, i) => i) // get the number of multiple 12 views we need to show
    let layout16 = Array.from({ length: Math.ceil(numCams / 16) }, (_, i) => i) // get the number of multiple 16 views we need to show
    switch (props.layoutConfig) {
      case '1':
        return (
          props.compositeCams.map((c,index) => (
             <p key={index}
                style={{
                  backgroundColor: props.camset === index ? 'lightgrey' : null,
                  color: props.camset === index ? 'black' : null,
                  border: props.camset === index ? '2px solid black' : null,
                  marginRight: 5,
                  marginLeft: 5,
                  paddingRight: 4,
                  paddingLeft: 4,
                  borderRadius: 5 }}
                className="cursor-pointer color-hover"
                onClick={() => props.updateCamset(index)}>
              {index + 1}
            </p>
          ))
        )
      case '4':
        return (
          layout4.map((l,index) =>(
            <p  key={index}
                style={{
                  backgroundColor: props.camset === index ? 'lightgrey' : null,
                  color: props.camset === index ? 'black' : null,
                  border: props.camset === index ? '2px solid black' : null,
                  marginRight: 5,
                  marginLeft: 5,
                  paddingRight: 4,
                  paddingLeft: 4,
                  borderRadius: 5 }}
                className="cursor-pointer color-hover"
                onClick={() => props.updateCamset(index)}>
              {paginationTemplate4[index]}
            </p>
          ))
        )
      case '6':
        return (
          layout6.map((l,index) =>(
            <p  key={index}
                style={{
                  backgroundColor: props.camset === index ? 'lightgrey' : null,
                  color: props.camset === index ? 'black' : null,
                  border: props.camset === index ? '2px solid black' : null,
                  marginRight: 5,
                  marginLeft: 5,
                  paddingRight: 4,
                  paddingLeft: 4,
                  borderRadius: 5 }}
                className="cursor-pointer color-hover"
                onClick={() => props.updateCamset(index)}>
              {paginationTemplate6[index]}
            </p>
          ))
        )
      case '9':
         return (
          layout9.map((l,index) =>(
            <p  key={index}
                style={{
                  backgroundColor: props.camset === index ? 'lightgrey' : null,
                  color: props.camset === index ? 'black' : null,
                  border: props.camset === index ? '2px solid black' : null,
                  marginRight: 5,
                  marginLeft: 5,
                  paddingRight: 4,
                  paddingLeft: 4,
                  borderRadius: 5 }}
                className="cursor-pointer color-hover"
                onClick={() => props.updateCamset(index)}>
              {paginationTemplate9[index]}
            </p>
          ))
        )
      case '12':
        return (
          layout12.map((l,index) =>(
            <p  key={index}
                style={{
                  backgroundColor: props.camset === index ? 'lightgrey' : null,
                  color: props.camset === index ? 'black' : null,
                  border: props.camset === index ? '2px solid black' : null,
                  marginRight: 5,
                  marginLeft: 5,
                  paddingRight: 4,
                  paddingLeft: 4,
                  borderRadius: 5 }}
                className="cursor-pointer color-hover"
                onClick={() => props.updateCamset(index)}>
              {paginationTemplate12[index]}
            </p>
          ))
        )
      case '16':
         return (
          layout16.map((l,index) =>(
            <p  key={index}
                style={{
                  backgroundColor: props.camset === index ? 'lightgrey' : null,
                  color: props.camset === index ? 'black' : null,
                  border: props.camset === index ? '2px solid black' : null,
                  marginRight: 5,
                  marginLeft: 5,
                  paddingRight: 4,
                  paddingLeft: 4,
                  borderRadius: 5 }}
                className="cursor-pointer color-hover"
                onClick={() => props.updateCamset(index)}>
              {paginationTemplate16[index]}
            </p>
          ))
        )
      default:
        return (
          <p>layout pagination</p>
        )
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', height: '15%' }}>
      {returnLayout()}
    </div>
  )
}

const mapStateToProps = state => {
  const { compositeCams } = state.data;
  const { layoutConfig , camset} = state.config;
  return {
    compositeCams,
    layoutConfig,
    camset
  }
}

export default connect(mapStateToProps,{updateCamset})(LayoutPagination);